import { Component, Input } from '@angular/core';
import { IncidentalAbsence, IncidentalAbsenceReason } from '../..';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-my-absence-grid',
    template: `
    <app-absence-grid
      class="tw-w-full"
      [translationRequest]="translationRequest"
      [absences]="myAbsenceData"
      [absencesLoading]="false"
      [reasonData]="reasonData"
      [employeeLinkEnabled]="false"
      [filterEnabled]="true"
      [ownAbsence]="true"
      noDataMessage="There are no absences."
    ></app-absence-grid>
  `,
    styles: [],
    standalone: false
})
export class MyAbsenceGridComponent {
  @Input()
  myAbsenceData: IncidentalAbsence[] = [];

  @Input()
  reasonData: IncidentalAbsenceReason[];
  
  @Input()
  translationRequest: TranslationRequest;
}
